type TValue = string | number | boolean | string[] | number[] | boolean[]

type TData = Record<string, TValue>

export class MyURLSearchParams extends URLSearchParams {
  constructor(data: TData) {
    super()

    Object.entries(data).forEach(([key, value]) => {
      if (value === null) {
        this.append(key, 'null')
      } else if (
        ['string', 'number', 'boolean', 'bigint'].includes(typeof value)
      ) {
        this.append(key, String(value))
      } else if (Array.isArray(value)) {
        value.forEach((valueItem) => {
          this.append(key, String(valueItem))
        })
      }
    })
  }
}
